module.exports = __webpack_public_path__ + "img/美容水(绿)_04.85a56286.jpg";